export function formatMessage(text) {
    // Remove as citações no formato 【n:n†source】
    let formattedText = text.replace(/【\d+:\d+†source】/g, "");

    // Adiciona quebras de linha antes de listas, marcadas por " - "
    formattedText = formattedText.replace(/ - /g, "<br/>- ");

    // Transforma os "**texto**" em <strong>texto</strong> para exibir negrito
    formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");

    // Adiciona quebra de linha antes de "- **palavra**" para capturar itens formatados
    formattedText = formattedText.replace(/<br\/>- <strong>/g, "<br/><br/>- <strong>");

    // Remove a quebra de linha após os pontos finais
    formattedText = formattedText.replace(/\.<br\/>/g, ".");

    // Evita quebra de linha em datas e valores após ":"
    formattedText = formattedText.replace(/:\s?(\d+\/\d+\/\d+|\d+)/g, ": $1");

    // Garante que qualquer lista (mesmo sem negrito) tenha a quebra correta
    formattedText = formattedText.replace(/- ([A-Za-zÀ-ÖØ-öø-ÿ0-9])/g, "<br/>- $1");

    // Adiciona quebra de linha antes de tópicos enumerados (1., 2., 3., etc.)
    formattedText = formattedText.replace(/(\d+)\.\s/g, "<br/>$1. ");

    // Formata títulos do tipo "Dados do Projeto:"
    formattedText = formattedText.replace(/(Dados do Projeto|Dados do Imóvel|Principais detalhes sobre o certificado):/g, "<br/><strong>$1:</strong><br/>");

    // Transforma itens de dados como "Número do Habite-se:" em negrito
    formattedText = formattedText.replace(/(-? [A-Za-zÀ-ÖØ-öø-ÿ ]+):/g, "<strong>$1:</strong>");

    return formattedText;
}
